import { bareChatId, conversationQueryKey } from '../../hooks/useConversation';
/**
 * Optimistically write a conversation title into the react-query caches so the
 * chat header (via useConversation) and the switcher/history list (['chats'])
 * update live. Mirrors the ChatSettings rename dual-write; used for the
 * server-streamed `title` event, where only a title (no full response) is on
 * hand — so the conversation entry is cloned/patched rather than replaced.
 */ export function applyConversationTitle(queryClient, chatId, title) {
    if (!title) return;
    queryClient.setQueryData(conversationQueryKey(chatId), (prev)=>{
        if (!prev?.conversation) return prev;
        // prev is a protobuf-es message; clone (new ref + preserves methods) rather
        // than spread into a plain object.
        const next = prev.clone();
        if (next.conversation) next.conversation.title = title;
        return next;
    });
    const bareId = bareChatId(chatId);
    const wireId = `shanks-${bareId}`;
    queryClient.setQueryData([
        'chats'
    ], (prev)=>{
        if (!prev) return prev;
        return {
            ...prev,
            chats: prev.chats.map((c)=>c.chatId === wireId || c.chatId === bareId ? {
                    ...c,
                    title
                } : c)
        };
    });
}
